import makeId from '../../utils/makeId';
import * as situations from '../../components/boxes/situations';

export const initialBoxes = [
  [
    {
      id: makeId(),
      props: {
        label: 4,
        situation: situations.IN_SHELL,
      },
    },
    {
      id: makeId(),
      props: {
        label: 7,
        situation: situations.IN_SHELL,
      },
    },
    {
      id: makeId(),
      props: {
        label: 3,
        situation: situations.IN_SHELL,
      },
    },
    {
      id: makeId(),
      props: {
        label: 12,
        situation: situations.IN_SHELL,
      },
    },
    {
      id: makeId(),
      props: {
        label: 1,
        situation: situations.IN_SHELL,
      },
    },
    {
      id: makeId(),
      props: {
        label: 10,
        situation: situations.IN_SHELL,
      },
    },
    {
      id: makeId(),
      props: {
        label: 5,
        situation: situations.IN_SHELL,
      },
    },
    {
      id: makeId(),
      props: {
        label: 20,
        situation: situations.IN_SHELL,
      },
    },
  ],
  [
    {
      id: makeId(),
      props: {
        label: 3,
        situation: situations.IN_SHELL,
      },
    },
    {
      id: makeId(),
      props: {
        label: 12,
        situation: situations.IN_SHELL,
      },
    },
    {
      id: makeId(),
      props: {
        label: 10,
        situation: situations.IN_SHELL,
      },
    },
    {
      id: makeId(),
      props: {
        label: 7,
        situation: situations.IN_SHELL,
      },
    },
    {
      id: makeId(),
      props: {
        label: 7,
        situation: situations.IN_SHELL,
      },
    },
    {
      id: makeId(),
      props: {
        label: 4,
        situation: situations.IN_SHELL,
      },
    },
    {
      id: makeId(),
      props: {
        label: 16,
        situation: situations.IN_SHELL,
      },
    },
    {
      id: makeId(),
      props: {
        label: 11,
        situation: situations.IN_SHELL,
      },
    },
  ],

  [
    {
      id: makeId(),
      props: {
        label: 4,
        situation: situations.IN_SHELL,
      },
    },
    {
      id: makeId(),
      props: {
        label: 1,
        situation: situations.IN_SHELL,
      },
    },
    {
      id: makeId(),
      props: {
        label: 5,
        situation: situations.IN_SHELL,
      },
    },
    {
      id: makeId(),
      props: {
        label: 3,
        situation: situations.IN_SHELL,
      },
    },
    {
      id: makeId(),
      props: {
        label: 8,
        situation: situations.IN_SHELL,
      },
    },
    {
      id: makeId(),
      props: {
        label: 3,
        situation: situations.IN_SHELL,
      },
    },
    {
      id: makeId(),
      props: {
        label: 1,
        situation: situations.IN_SHELL,
      },
    },
    {
      id: makeId(),
      props: {
        label: 4,
        situation: situations.IN_SHELL,
      },
    },
    {
      id: makeId(),
      props: {
        label: 7,
        situation: situations.IN_SHELL,
      },
    },
    {
      id: makeId(),
      props: {
        label: 5,
        situation: situations.IN_SHELL,
      },
    },
    {
      id: makeId(),
      props: {
        label: 2,
        situation: situations.IN_SHELL,
      },
    },
    {
      id: makeId(),
      props: {
        label: 9,
        situation: situations.IN_SHELL,
      },
    },
  ],

  [
    {
      id: makeId(),
      props: {
        label: 5,
        situation: situations.IN_SHELL,
      },
    },
    {
      id: makeId(),
      props: {
        label: 1,
        situation: situations.IN_SHELL,
      },
    },
    {
      id: makeId(),
      props: {
        label: 1,
        situation: situations.IN_SHELL,
      },
    },
    {
      id: makeId(),
      props: {
        label: 40,
        situation: situations.IN_SHELL,
      },
    },
    {
      id: makeId(),
      props: {
        label: 3,
        situation: situations.IN_SHELL,
      },
    },
    {
      id: makeId(),
      props: {
        label: 2,
        situation: situations.IN_SHELL,
      },
    },
    {
      id: makeId(),
      props: {
        label: 3,
        situation: situations.IN_SHELL,
      },
    },
    {
      id: makeId(),
      props: {
        label: 50,
        situation: situations.IN_SHELL,
      },
    },
    {
      id: makeId(),
      props: {
        label: 1,
        situation: situations.IN_SHELL,
      },
    },
    {
      id: makeId(),
      props: {
        label: 100,
        situation: situations.IN_SHELL,
      },
    },
  ],
];

export default initialBoxes;
